// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-KhgLM","close":"close-wxT0d"};